import React from 'react';
import { Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  SearchOutlined,
  ShopOutlined,
  SafetyCertificateOutlined,
  UserDeleteOutlined,
  UserOutlined,
  QqOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import './index.css';

const Sidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: '仪表盘',
    },
    {
      key: '/order-fill',
      icon: <FileTextOutlined />,
      label: '查G服务-订单填写',
    },
    {
      key: '/order-place',
      icon: <ShoppingCartOutlined />,
      label: '下单填写',
    },
    {
      key: '/query-info',
      icon: <SearchOutlined />,
      label: '查询信息',
    },
    {
      key: '/stores',
      icon: <ShopOutlined />,
      label: '店铺信息',
    },
    {
      key: '/health-certificates',
      icon: <SafetyCertificateOutlined />,
      label: '健康证',
    },
    {
      key: '/recruitment',
      icon: <QqOutlined />,
      label: '招聘推广',
    },
    {
      key: '/blacklist',
      icon: <UserDeleteOutlined />,
      label: '黑名单',
    },
    ...(user?.role === 'admin' ? [{
      key: '/users',
      icon: <UserOutlined />,
      label: '用户管理',
    }] : [])
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  return (
    <aside className={`app-sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-icon"></div>
          {!collapsed && (
            <div className="logo-text">
              <div className="logo-title">星火</div>
              <div className="logo-subtitle">反作弊系统</div>
            </div>
          )}
        </div>
      </div>
      
      <div className="sidebar-content">
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          className="sidebar-menu"
        />
      </div>
    </aside>
  );
};

export default Sidebar;
